import { useEffect, useState } from 'react'
import type { BannersConfig } from '@/types'
import { ImageUploadField } from '@/components/ImageUploadField'
import { Spinner } from '@/components/ui'
import { api } from '@/lib/api'
import { AdminSection } from './AdminSection'

/** §6.4 — El admin sube las 3 imágenes estáticas de banner que el vendedor
 *  puede descargar desde el modal de Social Selling. */
export function AdminBanners() {
  const [draft, setDraft] = useState<BannersConfig>({ story: '', post: '', thumb: '' })
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [saved, setSaved] = useState(false)
  const [err, setErr] = useState<string | null>(null)

  useEffect(() => {
    api
      .get<BannersConfig>('/banners')
      .then((b) => setDraft({ story: b.story ?? '', post: b.post ?? '', thumb: b.thumb ?? '' }))
      .catch((e) => setErr((e as Error).message))
      .finally(() => setLoading(false))
  }, [])

  const set = (k: keyof BannersConfig, v: string) => setDraft((d) => ({ ...d, [k]: v }))

  async function save() {
    setSaving(true)
    setSaved(false)
    setErr(null)
    try {
      await api.put('/banners', {
        story: draft.story?.trim() || undefined,
        post: draft.post?.trim() || undefined,
        thumb: draft.thumb?.trim() || undefined,
      })
      setSaved(true)
      setTimeout(() => setSaved(false), 2500)
    } catch (e) {
      setErr((e as Error).message)
    } finally {
      setSaving(false)
    }
  }

  return (
    <AdminSection title="Banners de Social Selling">
      {loading ? (
        <div className="flex justify-center py-10">
          <Spinner className="h-6 w-6 accent-text" />
        </div>
      ) : (
        <div className="space-y-4">
          <p className="text-sm text-ink-muted">
            Imágenes que el vendedor puede descargar desde el modal de compartir. Subí un archivo o pegá una URL.
          </p>
          <ImageUploadField
            label="Story (1080×1920)"
            value={draft.story ?? ''}
            onChange={(url) => set('story', url)}
            previewClassName="h-20 w-12"
          />
          <ImageUploadField
            label="Post (1080×1080)"
            value={draft.post ?? ''}
            onChange={(url) => set('post', url)}
          />
          <ImageUploadField
            label="Miniatura WhatsApp"
            value={draft.thumb ?? ''}
            onChange={(url) => set('thumb', url)}
          />
          {err && <div className="rounded-lg bg-danger/5 px-3 py-2 text-sm text-danger">{err}</div>}
          <button className="btn-primary btn-block" onClick={save} disabled={saving}>
            {saving ? <Spinner className="h-4 w-4" /> : saved ? '✅ Guardado' : 'Guardar cambios'}
          </button>
        </div>
      )}
    </AdminSection>
  )
}
